import http from './http';

export default {
  all() {
    return http().get(`/v1/tags`);
  },
  allContactTags() {
    return http().get(`/v1/tags/contacts`);
  },
  get(id) {
    return http().get(`/v1/tags/${id}`);
  },
  create(data) {
    return http().post(`/v1/tags/contacts`, data);
  },
  createTaskTag(data) {
    return http().post(`/v1/tags/tasks`, data);
  },
  update(data) {
    return http().put(`/v1/tags/${data.id}`, data);
  },
  delete(id) {
    return http().delete(`/v1/tags/${id}`);
  },
}
